import sumBy from "lodash/sumBy"
import React from "react"
import styles from "./styles.css"
import TagModal from "../../Item/TagModal"

const TEXT_FONT = `14px Source Sans Pro`
const getTextWidth = (text, font) => {
  const canvas =
    getTextWidth.canvas ||
    (getTextWidth.canvas = document.createElement(`canvas`))
  const context = canvas.getContext(`2d`)
  context.font = font
  const metrics = context.measureText(text)
  return Math.ceil(metrics.width + 20)
}

const TagsWithModal = ({ additionalTags, additionalWidth }) => {
  let count = 0
  const shortTags = []
  const otherTags = []
  let rawFactor = 0
  additionalTags.forEach(item => {
    count += item.width
    if (count < 250 - rawFactor) {
      shortTags.push({ text: item.text, width: item.width })
    } else {
      if (!rawFactor) {
        rawFactor = 75
        count = item.width
        shortTags.push({ text: item.text, width: item.width })
      }
      otherTags.push(item)
    }
  })
  otherTags.shift()
  return (
    <div className={styles.TagsCell}>
      {shortTags.map(field => (
        <div key={field.text}>
          <span className={field.width > 121 ? styles.BigTags : styles.Tags}>
            {field.text}
          </span>
          <span style={{ width: field.width }} />
        </div>
      ))}
      {otherTags.length ? (
        <TagModal tags={otherTags} modalLeftPosition={additionalWidth} />
      ) : null}
    </div>
  )
}

const MappedTags = ({ tags }) => {
  const newTagsArr = tags.map((tags, index) => ({
    text: tags,
    order: index,
    width:
      getTextWidth(tags, TEXT_FONT) > 122 ? 122 : getTextWidth(tags, TEXT_FONT),
    maxWidth: getTextWidth(tags, TEXT_FONT),
  }))
  const tagsWidth = sumBy(newTagsArr, o => o.width)
  if (tagsWidth < 400) {
    return (
      <div className={styles.TagsCell}>
        {newTagsArr.map(field => (
          <div key={field.text}>
            <span className={field.width > 121 ? styles.BigTags : styles.Tags}>
              {field.text}
            </span>
            <span style={{ width: field.width }} />
          </div>
        ))}
      </div>
    )
  }
  return (
    <TagsWithModal
      additionalTags={newTagsArr}
      additionalWidth={getTextWidth(
        `Ещё `.concat(newTagsArr.length).concat(`...`),
        `normal 14px Source Sans Pro`,
      )}
    />
  )
}

export default MappedTags
